// Shared menu + collection config for the header, footer and collection pages.
// Collection handles must match the collections you create in Shopify
// (Products > Collections). "under-250"/"under-500" work best as automated
// collections with a price condition.

export const COLLECTIONS = {
  'new-arrivals': {
    title: 'New Arrivals',
    blurb: 'The latest pieces to come through the studio door. Once they go, they go.',
  },
  paintings: {
    title: 'Paintings',
    blurb: 'Original oils, watercolours and works on paper, from vintage finds to local artists working today.',
  },
  ceramics: {
    title: 'Ceramics',
    blurb: 'Hand-thrown vessels, studio pottery and vintage pieces with the maker’s mark still on them.',
  },
  rugs: {
    title: 'Rugs',
    blurb: 'Hand-knotted and hand-woven rugs, chosen to be lived on for decades.',
  },
  'under-250': {
    title: 'Under $250',
    blurb: 'Real art doesn’t have to cost a fortune. Original pieces, all under $250.',
  },
  'under-500': {
    title: 'Under $500',
    blurb: 'Original works under $500, each one hand-selected.',
  },
}

export const ANNOUNCEMENTS = [
  'Hand-curated vintage art & interiors',
  'Real art, never printed in a factory',
  'Supporting local artists, one piece at a time',
]

// Items without a page yet point at "#" until those pages exist.
export const MAIN_MENU = [
  {
    label: 'Shop',
    links: [
      { label: 'New Arrivals', to: '/collections/new-arrivals' },
      { label: 'Shop All', to: '/shop' },
      { label: 'Paintings', to: '/collections/paintings' },
      { label: 'Ceramics', to: '/collections/ceramics' },
      { label: 'Rugs', to: '/collections/rugs' },
      { label: 'Under $250', to: '/collections/under-250' },
      { label: 'Under $500', to: '/collections/under-500' },
      { label: 'Gift Card', to: '/products/gift-card' },
    ],
  },
  {
    label: 'About',
    links: [
      { label: 'Our Story', to: '/#our-story' },
      { label: 'Meet the Artists', to: '#' },
      { label: 'How We Curate', to: '/#how-we-curate' },
      { label: 'Trade & Interiors', to: '#' },
      { label: 'Bespoke Requests', to: '#' },
    ],
  },
  {
    label: 'Contact',
    links: [
      { label: 'Get in Touch', to: '#' },
      { label: 'Studio Visits', to: '#' },
      { label: 'Pop-ups & Events', to: '#' },
      { label: 'The Letter', to: '/#newsletter' },
    ],
  },
]

const domain = process.env.VUE_APP_SHOPIFY_DOMAIN
export const ACCOUNT_URL =
  process.env.VUE_APP_SHOPIFY_ACCOUNT_URL || (domain ? `https://${domain}/account` : '#')
